import React, { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { Row, Col, Alert } from 'reactstrap'

import CarIssueTab from "./CarIssueTab"
import { HasPermissionsQuery } from "../../../Functions/querys"
import withApolloClient from '../../../withApolloClient'
import AdvancedFiltersControl from '../../../Filters/AdvancedFiltersControl'
import AppliedAdvancedFilters from '../../../Filters/AppliedAdvancedFilters'
import { buildPresets } from '../../../Filters/presetFilters'

// This tab's one default filter, expressed as an Advanced Filters preset --
// the same FilterInput shape the query already sends for user filters, so the
// popover, the chips and the query all read one source of truth. Editable:
// users could change the status filter on the legacy bar, so they still can.
// "OPEN"/"URGENT" are CarIssues.status's raw TextChoices values, not graphene
// enum names -- status is a plain CharField.
const CAR_ISSUE_PRESETS = buildPresets([
    { fieldName: "status", filterType: "in", filterValues: ["OPEN", "URGENT"], editable: true },
])

class CarIssuesTabContainer extends Component {
    constructor(props) {
        super(props)
        // presets and defaultPresets start out equal -- setPresets only ever
        // updates presets, so defaultPresets stays the declared set and is
        // what Reset returns to.
        this.state = {
            searchTerm: "",
            orderBy: ["-id"],
            presets: CAR_ISSUE_PRESETS,
            defaultPresets: CAR_ISSUE_PRESETS,
        }
    }

    setPresets = (presets) => this.setState({ presets })

    render() {
        return (
            <div className="tab-container">
                {this.props.hasPermissions && !this.props.hasPermissions.includes("change_carissues") ? <Row><Col xs={12}><Alert color="danger">Sorry, you don’t have permission to view this section. For access, please contact the administrator.</Alert></Col></Row> : <>
                    <div>
                        <Row className="pb-3">
                            <Col xs="auto" className="p-0">
                                <AdvancedFiltersControl
                                    entity="car_issue"
                                    presets={this.state.presets}
                                    setPresets={this.setPresets}
                                    defaultPresets={this.state.defaultPresets}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} className="mt-2 search-filter-container">
                                <AppliedAdvancedFilters
                                    entity="car_issue"
                                    context={null}
                                    presets={this.state.presets}
                                    onPresetsChange={this.setPresets}
                                />
                            </Col>
                        </Row>
                    </div>
                    <CarIssueTab
                        {...this.props}
                        id={this.props.id ? this.props.id : null}
                        currentUser={this.props.currentUser}
                        searchTerm={this.state.searchTerm}
                        presets={this.state.presets}
                    />
                </>}
            </div>
        )
    }
}


//-----------------------------------
export default graphql(HasPermissionsQuery, {
    options: () => ({
        variables: {
            userPermissions: ["change_carissues"],
        },
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true,
    }),
    props: ({ data: { hasPermissions, loading, variables } }) => ({
        hasPermissions,
        loadingHasPermissions: loading,
        permissionVariables: variables,
    }),
})(withApolloClient(CarIssuesTabContainer));


